/**
 * 앱의 '예약금 결제' 전용 창 — iOS `LessonPaymentWebView`(전체화면 커버) 안에서 열렸는지와 닫기.
 *
 * 왜 필요한가: 결제 결과 화면(`/payment/result`)은 뒤로가기 없는 화면이라 웹 레이아웃이
 *  하단 탭바를 붙인다. 브라우저에서는 괜찮지만 앱의 결제 창 안에서는 탭바로 앱 전체를 돌아다닐 수
 *  있게 되어, 결제 창이 닫히지 않은 채 그 안에 다른 화면이 쌓인다(2026-09-24 iOS 테스트).
 *  결제 창에서는 탭바·뒤로가기를 숨기고, 나가는 길은 '닫기' 하나로만 둔다.
 *
 * 판별: 결제 창이 주입하는 표시로만 판단한다(주소·히스토리로 추측하지 않는다).
 *  - `__muyeonPaymentAppScheme` : 결제 창이면 항상 있다(카드 앱 복귀용 스킴, util/tossPayment.js).
 *  - `__muyeonPaymentSheetClosable` : 웹에서 창을 닫을 수 있는 앱 버전(closePaymentSheet 수신)에만 있다.
 *    구버전 앱은 이 신호를 모르므로, 그때는 버튼 대신 상단 '닫기' 안내를 보여 준다.
 *  안드로이드도 2026-10-24부터 같은 결제 창(LessonPaymentActivity)을 쓴다 — 같은 표시를 심고,
 *  신호는 그 창의 window.AppBridge(문자열 JSON)로 받는다. 구버전 안드로이드 앱(메인 웹뷰 결제)은 표시가 없어 기존 화면 그대로다.
 */

/** 결제 창에 신호 보내기 — iOS 는 messageHandlers, 안드로이드는 결제 창의 AppBridge. */
const postToPaymentSheet = (action) => {
  const ios = window.webkit?.messageHandlers?.callbackHandler;
  if (ios) { ios.postMessage({ action }); return; }
  window.AppBridge?.postMessage?.(JSON.stringify({ action }));
};
export const isInPaymentSheet = () =>
  typeof window !== "undefined" && !!window.__muyeonPaymentAppScheme;

export const canClosePaymentSheet = () =>
  isInPaymentSheet() && !!window.__muyeonPaymentSheetClosable;

/** 결제 창을 닫아 달라고 앱에 알린다. 닫히면 앱이 예약 화면을 새로 읽는다. */
export function closePaymentSheet() {
  try {
    postToPaymentSheet("closePaymentSheet");
    return true;
  } catch {
    return false;
  }
}

/**
 * 결제 승인 성공을 앱에 알린다(결과 화면이 승인 직후 1회).
 *  앱은 이걸 기억했다가 결제 창이 닫힐 때(확인·상단 닫기 무관) 예약 시트를 닫고 '내 예약' 으로 보낸다.
 *  신호를 모르는 구버전 앱은 무시한다.
 */
export function notifyPaymentCompleted() {
  if (!isInPaymentSheet()) return;
  try {
    postToPaymentSheet("paymentCompleted");
  } catch {
    /* noop */
  }
}
